import './AddArtworkToArtlistLoader.css';

export default function AddArtworkToArtlistLoader({ className = '', thin }) {
  return (
    <div
      className={`add-artwork-to-artlist-loader ${thin ? 'thin' : ''} ${className}`}
    />
  );
}
